import { shallowRef } from 'vue'

const trackingKeys = ['utm_source', 'utm_campaign', 'promoter_id'] as const
type TrackingKey = (typeof trackingKeys)[number]
type ShareTrackingParams = Partial<Record<TrackingKey, string>>

// 仅保存在进程内存中；切到后台保留，结束小程序进程后自然清空。
const sessionParams = shallowRef<ShareTrackingParams>({})

export function clearShareTrackingParams() {
  sessionParams.value = {}
}

export function captureShareTrackingParams(query?: Record<string, unknown>) {
  if (!query) return

  const params: ShareTrackingParams = {}
  for (const key of trackingKeys) {
    const value = query[key]
    if (typeof value === 'string' || typeof value === 'number') {
      params[key] = String(value)
    }
  }

  // 普通前后台切换没有推广参数时，继续使用本会话的来源。
  if (Object.keys(params).length) sessionParams.value = params
}

export function getShareTrackingParams(): ShareTrackingParams {
  return { ...sessionParams.value }
}

export function withShareTrackingParams(url: string): string {
  const params = sessionParams.value
  if (!Object.keys(params).length) return url

  const hashIndex = url.indexOf('#')
  const hash = hashIndex < 0 ? '' : url.slice(hashIndex)
  const route = hashIndex < 0 ? url : url.slice(0, hashIndex)
  const queryIndex = route.indexOf('?')
  const path = queryIndex < 0 ? route : route.slice(0, queryIndex)
  const query = queryIndex < 0 ? '' : route.slice(queryIndex + 1)
  const entries = query.split('&').filter((entry) => {
    if (!entry) return false
    try {
      const key = decodeURIComponent(entry.split('=')[0])
      return !Object.prototype.hasOwnProperty.call(params, key)
    } catch {
      return true
    }
  })

  for (const key of trackingKeys) {
    if (params[key] !== undefined) entries.push(`${key}=${encodeURIComponent(params[key])}`)
  }

  return `${path}?${entries.join('&')}${hash}`
}
